import { render, staticRenderFns } from "./VuePiano.vue?vue&type=template&id=869d82e2&scoped=true&"
import script from "./VuePiano.vue?vue&type=script&lang=js&"
export * from "./VuePiano.vue?vue&type=script&lang=js&"
import style0 from "./VuePiano.vue?vue&type=style&index=0&id=869d82e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869d82e2",
  null
  
)

export default component.exports